export default __webpack_public_path__ + "static/media/alert_signal.eceaf613.svg";